import { forwardRef, type InputHTMLAttributes } from 'react'

export type RadioInputProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'type'
>

export const RadioInput = forwardRef<HTMLInputElement, RadioInputProps>(
  function Input(props, ref) {
    return <input type="radio" ref={ref} {...props} />
  },
)
